import React from 'react';
import BannerImage from '../../../../assets/images/banner.png';
// import '../Banner/banner.css';
import {Grid, Slide, Typography} from "@mui/material";

const Banner = () => {
    return (
        <>
            <Grid sx={{
                backgroundImage: `url(${BannerImage})`,
                width: '100%',
                height: '90vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'right',
                textAlign: {xs: 'center', md: "left", lg: "left"},
                flexDirection: 'column',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPositionX: {xs: '-140px', md: 0}
            }}>
                <Grid sx={{
                    width: 'auto',
                    marginLeft: {xs: 0, md: "132px", lg: '132px'},
                    marginTop: {xs: '50%', md: '-16%'}
                }}>
                    <Slide direction={'down'} in={true} mountOnEnter timeout={1000}>
                        <Typography
                            sx={{
                                fontFamily: 'sen',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '36px',
                                lineHeight: '48px',
                                fontWeight: 700,
                                color: '#FFD050',
                            }}>
                            Happiness
                        </Typography>
                    </Slide>
                    <Slide direction={'left'} in={true} mountOnEnter timeout={1000}>

                        <Typography sx={{
                            fontFamily: 'sen',
                            padding: 0,
                            fontSize: '40px',
                            lineHeight: '48px',
                            fontWeight: 700,
                            color: '#fff'
                        }}>
                            یه حس خوب،<br/>با یه روز خوب
                        </Typography>
                    </Slide>
                    <Slide direction={'right'} in={true} mountOnEnter timeout={1000}>

                        <Typography sx={{color: "#fff", fontSize: "18px", lineHeight: '32px', my: 2,}}>
                            برنامه شادی و ورزش در محل کار شما
                        </Typography>
                    </Slide>
                </Grid>
            </Grid>
        </>
    );
};

export default Banner;



